<div *ngIf="templateRef">
  <ng-container
    *ngTemplateOutlet="templateRef; context: {$implicit: dataItem, closeCallback: closeCallback()}"></ng-container>
</div>
